import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/event`;

export type VolunteerEventDto = {
    id: number;
    name: string;
    shortName?: string;
    status?: string;
    abbreviation?: string;
    orgAbbreviation?: string;
    level?: string;
};

export const getAllEvents = (): Promise<VolunteerEventDto[]> =>
    axios.get(`${API_URL}/getAllEvents`).then(response => response.data);
